import React from 'react';
import {
  Users,
  Star,
  BookOpen,
  Heart,
  Mail
} from 'lucide-react';

const Staff = () => {
  // Staff data will be added here
  const leadership = [
    {
      name: 'Jonathan Dascal',
      title: 'TAG Principal',
      email: 'JDascal@schools.nyc.gov',
      bio: 'Leading TAG School for Young Scholars with dedication to gifted education.',
      image: 'bg-primary-700',
      specialties: ['Educational Leadership', 'Gifted Education']
    },
    {
      name: 'Dr. Jennifer Cosme',
      title: 'TAG Assistant Principal',
      email: 'JCosme2@schools.nyc.gov',
      bio: 'Supporting academic excellence and student development at TAG School.',
      image: 'bg-gold-800',
      specialties: ['Academic Support', 'Student Development']
    }
  ];
  const faculty = [
    { name: 'Sonia Deane', title: 'Kindergarten Teacher - 072 (K-112)', email: 'SDeanemann@schools.nyc.gov' },
    { name: 'Meliza Anzures', title: 'Kindergarten Teacher - 071 (K-113)', email: 'MAnzures@schools.nyc.gov' },
    { name: 'Kristine Terzi', title: '1st Grade Teacher - 171 (1-119)', email: 'KTerzi@schools.nyc.gov' },
    { name: 'Llyod Rivera', title: '1st Grade Teacher - 172 (1-121)', email: 'LRivera83@schools.nyc.gov' },
    { name: 'Amanda Wittels', title: '2nd Grade Teacher - 272 (2-124)', email: 'AWittels@schools.nyc.gov' },
    { name: 'Sophie Hopper', title: '2nd Grade Teacher - 271 (2-122)', email: 'SHopper3@schools.nyc.gov' },
    { name: 'Doreen Donnelly', title: '3rd Grade Teacher - 371 (3-117)', email: 'DDonnelly3@schools.nyc.gov' },
    { name: 'Julia Kim', title: '3rd Grade Teacher - 372 (3-123)', email: 'JKim94@schools.nyc.gov' },
    { name: 'Cassandra Shea', title: '4th Grade Teacher - 471 (4-212)', email: 'CBova@schools.nyc.gov' },
    { name: 'Derek Wohlleb', title: '4th Grade Teacher - 472 (4-210)' },
    { name: 'Edika Arinus', title: '4th Grade Teacher - 473 (4-126)', email: 'EArinus@schools.nyc.gov' },
    { name: 'Michella Saavedra', title: '5th/6th Grade ELA Teacher - Homeroom 571', email: 'MSaavedra@schools.nyc.gov' },
    { name: 'Zack Schwab', title: '5th/6th Grade Math Teacher - 572 Homeroom', email: 'ZSchwab@schools.nyc.gov' },
    { name: 'Fani Campanelli', title: '5th/6th Grade Social Studies Teacher - Homeroom 573', email: 'FBogiatzis@schools.nyc.gov' },
    { name: 'Michelle Erdos', title: '5th/6th Grade Science Teacher - Homeroom 640', email: 'MErdos2@schools.nyc.gov' },
    { name: 'Adam Branson', title: '5th/6th Career and Occupational Studies - Homeroom 641', email: 'JBranson2@schools.nyc.gov' },
    { name: 'Denise Roberts', title: '7th/8th Grade ELA - Homeroom 740', email: 'DRoberts20@schools.nyc.gov' },
    { name: 'Martelle Goodin', title: '7th/8th Grade Math and Algebra Teacher - Homeroom 741', email: 'MGoodin@schools.nyc.gov' },
    { name: 'Adnan El Rowmeim', title: '7th/8th Science and Living Environment - Homeroom 840', email: 'AElRowm@schools.nyc.gov' },
    { name: 'Colleen Hamill', title: '7th/8th Social Studies Teacher and US History - Homeroom 841', email: 'CHamill2@schools.nyc.gov' },
    { name: 'Shawn Harris', title: '6th–8th Civics and Social Justice / Health - Homeroom 842', email: 'Sharris30@schools.nyc.gov' },
    { name: 'Carly Shaw', title: 'K–4 Music Teacher / 5th and 8th Grade Chorus', email: 'CShaw10@schools.nyc.gov' },
    { name: 'Richard Faulkner', title: '5th–8th Grade Music Teacher', email: 'RFaulkner@schools.nyc.gov' },
    { name: 'Andy Wong', title: '1–8 Physical Education Teacher', email: 'AWong17@schools.nyc.gov' },
    { name: 'Miguelina Castaldi', title: '5–8 Spanish Teacher', email: 'MCastaldi@schools.nyc.gov' },
    { name: 'Nicholas Graham', title: '6–8 Inquire Teacher', email: 'NGraham10@schools.nyc.gov' },
    { name: 'Suzanne Tabrizi', title: 'K–8 Art Teacher', email: 'STabrizi@schools.nyc.gov' },
    { name: 'Eileen Finn', title: 'K–5th Grade Technology', email: 'EFinn2@schools.nyc.gov' }
  ];
  const support = [
    { name: 'Brianna Bova', title: 'Parent Coordinator', email: 'BBova@schools.nyc.gov' },
    { name: 'Danielle Wilbourne', title: 'School Secretary', email: 'DWilborne@schools.nyc.gov' },
    { name: 'Maritza Apella', title: 'Family Assistant / Transportation Coordinator', email: 'MApella@schools.nyc.gov' },
    { name: 'Violeta Trifu', title: 'ENL Teacher Coordinator', email: 'VTrifu@schools.nyc.gov' },
    { name: 'Donnah Ignacia Garcia', title: 'K-2 ICT/SETTS', email: 'DGarcia69@schools.nyc.gov' },
    { name: 'Magda Korewa', title: '3rd & 4th Grade ICT', email: 'MKorewa2@schools.nyc.gov' },
    { name: 'Elaine Tang', title: '5th-8th Grade ICT/Math', email: 'ETang2@schools.nyc.gov' },
    { name: 'Courtney Becker', title: '5th-8th Grade ICT/ELA', email: 'CBecker11@schools.nyc.gov' },
    { name: 'Ms. Bermudez', title: 'Speech-Language Pathologist', email: 'Abermudez4@schools.nyc.gov' },
    { name: 'Monica Popa', title: 'Physical Therapist', email: 'MPopa@schools.nyc.gov' },
    { name: 'Katelyn Dobranski', title: 'Occupational Therapist', email: 'KDobranski@schools.nyc.gov' },
    { name: 'Michelle Yrigoyen', title: 'K–8 Guidance Counselor', email: 'MYrigoyen@schools.nyc.gov' },
    { name: 'Erica Aris-Vidal', title: 'Community Coordinator', email: 'EArias@schools.nyc.gov' }
  ];

  return (
    <main id="main-content" className="bg-white pt-20">
      {/* Hero Section */}
      <section className="section-padding hero-gradient text-white">
        <div className="container-padding">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-3 bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20 mb-8">
              <Users className="h-5 w-5" />
              <span className="text-sm font-medium tracking-wide uppercase">Our Team</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-light mb-8 leading-tight">
              <span className="block font-extralight text-white/90">Meet Our</span>
              <span className="block font-medium">Dedicated Faculty</span>
            </h1>

            <p className="text-xl text-white/90 mb-12 font-light max-w-3xl mx-auto leading-relaxed">
              Our exceptional team of educators brings passion, expertise, and dedication to every classroom,
              ensuring each student receives the personalized attention they deserve.
            </p>
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="section-padding bg-white">
        <div className="container-padding">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-primary-100 text-primary-700 px-4 py-2 rounded-full mb-6">
              <Star className="h-4 w-4" />
              <span className="text-sm font-medium">Leadership</span>
            </div>
            <h2 className="text-4xl font-light text-primary-900 mb-6">School Leadership</h2>
            <p className="text-lg text-primary-700 max-w-3xl mx-auto font-light">
              Our experienced leadership team guides TAG School with vision, integrity, and a deep commitment
              to educational excellence.
            </p>
          </div>

          {leadership.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {leadership.map((leader, index) => (
                <div key={index} className="bg-white rounded-2xl p-8 card-hover shadow-lg border border-neutral-200">
                  <div className={`w-24 h-24 ${leader.image} rounded-xl flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold shadow-lg`}>
                    {leader.name.split(' ').map(n => n[0]).join('')}
                  </div>

                  <div className="text-center">
                    <h3 className="text-xl font-medium text-primary-900 mb-2">{leader.name}</h3>
                    <p className="text-gold-700 font-medium mb-2">{leader.title}</p>
                    {leader.email && (
                      <div className="flex items-center justify-center space-x-2 mb-4">
                        <Mail aria-hidden="true" className="h-4 w-4 text-primary-700" />
                        <a href={`mailto:${leader.email}`} className="text-primary-700 hover:text-primary-800 text-sm">
                          {leader.email}
                        </a>
                      </div>
                    )}
                    <p className="text-primary-700 font-light mb-6 leading-relaxed">{leader.bio}</p>

                    <div className="flex flex-wrap justify-center gap-2">
                      {leader.specialties.map((specialty, specIndex) => (
                        <span key={specIndex} className="bg-primary-50 text-primary-700 px-3 py-1 rounded-full text-sm">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="max-w-2xl mx-auto text-center">
              <div className="bg-neutral-50 rounded-2xl p-12 border border-neutral-200">
                <Users className="h-16 w-16 mx-auto mb-6 text-primary-300" />
                <p className="text-lg text-primary-700 font-light">
                  Leadership team information will be available soon. Please check back later.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Faculty */}
      <section className="section-padding bg-neutral-50">
        <div className="container-padding">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-gold-100 text-gold-700 px-4 py-2 rounded-full mb-6">
              <BookOpen className="h-4 w-4" />
              <span className="text-sm font-medium">Faculty</span>
            </div>
            <h2 className="text-4xl font-light text-primary-900 mb-6">Our Teaching Team</h2>
            <p className="text-lg text-primary-700 max-w-3xl mx-auto font-light">
              Meet the passionate educators who inspire and challenge our students every day,
              bringing expertise and creativity to the classroom.
            </p>
          </div>

          {faculty.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {faculty.map((teacher, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 card-hover shadow-lg border border-neutral-200">
                  <div className="w-20 h-20 bg-gold-800 rounded-xl flex items-center justify-center mx-auto mb-4 text-white text-lg font-bold shadow-lg">
                    {teacher.name.split(' ').map(n => n[0]).join('')}
                  </div>

                  <div className="text-center">
                    <h3 className="text-lg font-medium text-primary-900 mb-1">{teacher.name}</h3>
                    <p className="text-gold-700 font-medium text-sm mb-3">{teacher.title}</p>

                    {teacher.email && (
                      <div className="flex items-center justify-center space-x-2 mt-3">
                        <Mail aria-hidden="true" className="h-4 w-4 text-primary-700" />
                        <a href={`mailto:${teacher.email}`} className="text-primary-700 hover:text-primary-800 text-xs break-all">
                          {teacher.email}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="max-w-2xl mx-auto text-center">
              <div className="bg-white rounded-2xl p-12 border border-neutral-200">
                <BookOpen className="h-16 w-16 mx-auto mb-6 text-gold-300" />
                <p className="text-lg text-primary-700 font-light">
                  Faculty information will be available soon. Please check back later.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Support Staff */}
      <section className="section-padding bg-white">
        <div className="container-padding">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-primary-100 text-primary-700 px-4 py-2 rounded-full mb-6">
              <Heart className="h-4 w-4" />
              <span className="text-sm font-medium">Support Team</span>
            </div>
            <h2 className="text-4xl font-light text-primary-900 mb-6">Student Support Services</h2>
            <p className="text-lg text-primary-700 max-w-3xl mx-auto font-light">
              Our dedicated support team ensures every student has access to the resources and assistance
              they need to succeed academically and personally.
            </p>
          </div>

          {support.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {support.map((staff, index) => (
                <div key={index} className="bg-neutral-50 rounded-xl p-6 border border-neutral-200">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Heart className="h-6 w-6 text-primary-700" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-medium text-primary-900 mb-1">{staff.name}</h3>
                      <p className="text-gold-700 font-medium text-sm mb-3">{staff.title}</p>
                      {staff.email && (
                        <div className="flex items-center space-x-2">
                          <Mail aria-hidden="true" className="h-4 w-4 text-primary-700" />
                          <a href={`mailto:${staff.email}`} className="text-primary-700 hover:text-primary-800 text-sm break-all">
                            {staff.email}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="max-w-2xl mx-auto text-center">
              <div className="bg-neutral-50 rounded-2xl p-12 border border-neutral-200">
                <Heart className="h-16 w-16 mx-auto mb-6 text-primary-300" />
                <p className="text-lg text-primary-700 font-light">
                  Support staff information will be available soon. Please check back later.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Staff;